"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getGridListColumns;
/**
 * Sets column numbers based on number of items in a list.
 *
 * @param cardNumber
 * @returns
 */
function getGridListColumns(cardNumber) {
    if (cardNumber === 1) {
        return { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 };
    }
    else if (cardNumber === 2) {
        return { xs: 1, sm: 2, md: 2, lg: 2, xl: 2 };
    }
    else if ([3, 6].includes(cardNumber)) {
        return { xs: 1, sm: 2, md: 3, lg: 3, xl: 3 };
    }
    else if ([4, 7, 8, 11, 12, 16].includes(cardNumber)) {
        return { xs: 1, sm: 2, md: 2, lg: 4, xl: 4 };
    }
    else if ([5, 9, 13, 14, 15, 17, 18, 19].includes(cardNumber)) {
        return { xs: 1, sm: 2, md: 3, lg: 3, xl: 5 };
    }
    else if (cardNumber === 10) {
        return { xs: 1, sm: 2, md: 2, lg: 4, xl: 5 };
    }
    else {
        return { xs: 1, sm: 2, md: 3, lg: 4, xl: 5 };
    }
}
//# sourceMappingURL=GridListColumnsHelper.js.map